<ui-avatar
[iconBackgroundColor]="backgroundColour"
 [isSquare]="true" [slIcon]="{ name: iconType, theme: 'bold', svgStyle: {'padding-bottom': '2px'} }" [size]="size"
 textColor="text-white"
 ></ui-avatar>
